//Advanced Search Filter options
//For Mock Up only, NEEDS to be removed
export const getSearchOptions = () => {
  return ({
    categoryOptions: [
      {
        id: '001',
        text: 'Road',
        value: 'Road',
      },
      {
        id: '002',
        text: 'Feature',
        value: 'Feature',
      },
      {
        id: '0003',
        text: 'Aboriginal Community',
        value: 'Aboriginal Community',
      },
      {
        id: '0004',
        text: 'Park or Cemetery',
        value: 'Park or Cemetery',
      },
      {
        id: '0005',
        text: 'Administrative Area',
        value: 'Administrative Area',
      },
      {
        id: '0006',
        text: 'Infrastructure',
        value: 'Infrastructure',
      },
      {
        id: '0007',
        text: 'Point of Interest',
        value: 'Point of Interest',
      },
    ].sort((a, b) => a.value > b.value ? 1 : -1),
    statusOptions:
      [
        {
          id: 1,
          'text': 'Assigned',
          'value': 'Assigned',
        },
        {
          id: 2,
          'text': 'Historical',
          'value': 'Historical',
        },
        {
          id: 3,
          'text': 'Proposed',
          'value': 'Proposed',
        },
        {
          id: 4,
          'text': 'Recorded',
          'value': 'Recorded',
        },
        {
          id: 5,
          'text': 'Recorded - Historical',
          'value': 'Recorded - Historical',
        },
        {
          id: 6,
          'text': 'Registered',
          'value': 'Registered',
        },
        {
          id: 7,
          'text': 'Registered - Historical',
          'value': 'Registered - Historical',
        },
        {
          id: 8,
          'text': 'Reserve List',
          'value': 'Reserve List',
        },
        {
          id: 9,
          'text': 'Revoked',
          'value': 'Revoked',
        },
      ].sort((a, b) => a.value > b.value ? 1 : -1),
  })
}